export const dateKey = (date) => [
  date.getFullYear(),
  String(date.getMonth() + 1).padStart(2, '0'),
  String(date.getDate()).padStart(2, '0'),
].join('-');

export function mondayOf(date) {
  const d = new Date(date);
  d.setHours(12, 0, 0, 0);
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return d;
}

// Nombre de semaines consécutives (jusqu'à la semaine en cours ou précédente) avec au moins une séance
export function computeStreak(sessions, now = new Date()) {
  const weeks = new Set(sessions.map((s) => dateKey(mondayOf(new Date(`${s.date}T12:00:00`)))));
  const check = mondayOf(now);
  if (!weeks.has(dateKey(check))) check.setDate(check.getDate() - 7);
  let streak = 0;
  while (weeks.has(dateKey(check))) {
    streak++;
    check.setDate(check.getDate() - 7);
  }
  return streak;
}

// Grille [semaine][jour lundi→dimanche] ; null pour les jours à venir
export function buildHeatMap(sessions, weeks = 16, now = new Date()) {
  const counts = {};
  sessions.forEach((s) => { counts[s.date] = (counts[s.date] || 0) + 1; });
  const today = new Date(now);
  today.setHours(12, 0, 0, 0);
  const start = mondayOf(today);
  start.setDate(start.getDate() - (weeks - 1) * 7);
  const grid = [];
  for (let w = 0; w < weeks; w++) {
    const week = [];
    for (let d = 0; d < 7; d++) {
      const cell = new Date(start);
      cell.setDate(start.getDate() + w * 7 + d);
      if (cell > today) { week.push(null); continue; }
      const key = dateKey(cell);
      week.push({ date: key, count: counts[key] || 0 });
    }
    grid.push(week);
  }
  return grid;
}

// Jour de la semaine façon planning : 0 = lundi … 6 = dimanche
export const weekdayIndex = (date = new Date()) => (date.getDay() + 6) % 7;

export const WEEKDAYS = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
